import {
    DomElementAnimator,
    IInnerWindowController,
    ModalsScope,
    ObservableRenderFunction,
    useInnerWindowController,
    useObservableRenderFunction
} from "@wix/devzai-utils-react";
import {classes, style} from './doppe-viewer-modals-controller.st.css';
import React from "react";
import {assertNotNullable, Evaluable, evaluateWhenFunction} from "@wix/devzai-utils-common";

export class DoppeViewerModalsController {

    private modalsScope;

    constructor (
        options: {
            modalsScope: ModalsScope;
        }
    ) {
        this.modalsScope = options.modalsScope;
    }

    public showInnerModal (
        options: {
            content: DoppeViewerModalContent;
        }
    ) {
        const {
            content
        } = options;

        this.modalsScope.showModal({
            content: () => (
                <DomElementAnimator
                    autoAnimateOnMount={{
                        animation: [
                            {opacity: 0, easing: 'ease'},
                            {opacity: 1, easing: 'ease'}
                        ],
                        durationMilliseconds: 200
                    }}
                >
                    <DoppeViewerModalContentRenderer>
                        {content}
                    </DoppeViewerModalContentRenderer>
                </DomElementAnimator>
            ),
            overlay: (
                <DomElementAnimator
                    autoAnimateOnMount={{
                        animation: [
                            {opacity: 0, easing: 'ease'},
                            {opacity: 1, easing: 'ease'}
                        ],
                        durationMilliseconds: 200
                    }}
                >
                    <div
                        className={style(classes.overlay, {})}
                    />
                </DomElementAnimator>

            )
        })

    }
}

export type DoppeViewerModalContent = Evaluable<(renderProps: {modalController: IInnerWindowController}) => React.ReactElement | ObservableRenderFunction>;

const DoppeViewerModalContentRenderer = React.memo(function DoppeViewerModalContentRenderer (
    props: {
        children: DoppeViewerModalContent;
    }
) {
    const {
        children
    } = props;

    const modalController = assertNotNullable(useInnerWindowController());

    const evaluatedContent = evaluateWhenFunction(children, {modalController: modalController})

    return useObservableRenderFunction(evaluatedContent);
});